module.exports = __webpack_public_path__ + "static/scott-3970a936a2460378472dfddca8cb8603.jpg";